import { teApi } from 'yxt-biz-pc/packages/api';

export const getAuditFormInfo = (formId) => {
  return teApi.get(`/pay/course/dev/detail4audit/${formId}`);
};
